// Set by CreateWorker on every worker it spawns (node: env var, browser:
// Worker name) so IsWorker() only reports true for workers we created
// ourselves, not any process/thread that happens to look like one.
export const WORKER_MARKER = "pdfking-worker"
